import {
  RequestableSaasDestination,
  SaaSDestination,
  saasDestinations,
} from "../destinations/destinations";
import { useFunctionDestinations } from "./useFunctionDestinations";

export const useAllSaasDestinations = (): {
  [destSlug: string]: SaaSDestination | RequestableSaasDestination | undefined;
} => {
  const functionDestinations = useFunctionDestinations();
  return { ...saasDestinations, ...functionDestinations };
};
